<div [formGroup]="form">
  @if (isPartnerRequired) {
    <nimbus-input-autocomplete
      defaultSearch
      formControlName="partnerId"
      [label]="TranslationKeys.GeneralPartner | icuTranslate: PluralForm.One"
      [options]="partners$ | async"
      [required]="required"
    ></nimbus-input-autocomplete>
  }
  <nimbus-input-autocomplete
    defaultSearch
    [formControl]="control"
    [label]="TranslationKeys.GeneralTenant | icuTranslate: PluralForm.One"
    [options]="tenants$ | async"
    [required]="required"
  ></nimbus-input-autocomplete>
</div>
